// combineNode.js
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const CombineNode = ({ id, data }) => {
    return (
        <BaseNode
            id={id}
            data={data}
            title="Combine"
            handles={[
                { type: 'target', position: Position.Left, id: `${id}-in-1`, style: { top: '30%' } },
                { type: 'target', position: Position.Left, id: `${id}-in-2`, style: { top: '70%' } },
                { type: 'source', position: Position.Right, id: `${id}-output` }
            ]}
        >
            <div className="text-sm text-gray-500">
                <span>Merge 2 inputs</span>
            </div>
        </BaseNode>
    );
};
